// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + {"2916":"styleBundle2","5725":"styleBundle3","6617":"styleBundleCritical","9119":"styleBundle1"}[chunkId] + ".css";
};